import * as React from 'react'
import { CheckBox, Label } from 'react-rails-form-helpers'
import { PaymentDetails } from '../../Checkout/lib/payment_details'
import { TaxInformation } from '../../Checkout/lib/tax_information'

interface IProps {
  termsOfService: boolean
  paymentDetails: PaymentDetails
  taxInformation: TaxInformation
  children?: React.ReactNode
  submitButtonRef: React.Ref<HTMLButtonElement>
  ctaText: string
}

interface IState {
  termsOfService: boolean
}

export class ThreeYearTermsOfService extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { termsOfService } = props

    this.state = {
      termsOfService,
    }
  }

  public toggleTermsOfService = () => {
    const { termsOfService } = this.state

    this.setState({
      termsOfService: !termsOfService,
    })
  }

  public render() {
    const { ctaText, children, submitButtonRef } = this.props
    const { termsOfService } = this.state

    return (
      <section className="terms-of-service">
        <h2>About Your Plan</h2>

        {children}

        {this.renderTermsBullets()}

        <div className="callout">
          <Label htmlFor="terms_of_service" className="terms-checkbox-label text-center">
            <CheckBox
              name="terms_of_service"
              value={termsOfService ? 1 : 0}
              defaultChecked={termsOfService}
              onClick={this.toggleTermsOfService}
              required={true}
            />{' '}
            I have read the above information and agree to the{' '}
            <a href="/terms" title="Terms of Service" target="_blank">Terms of Service</a>
          </Label>
          <button
            id="cashier_submit"
            className="button pill padded"
            type="submit"
            ref={submitButtonRef}
          >
            {ctaText}
          </button>
        </div>

      </section>
    )
  }

  private renderTermsBullets() {
    return (
      <ul>
        <li>
          You will be charged <strong>${this.renderedPaymentTotal()}</strong> (includes applicable tax) today.
        </li>
        <li>
          You are purchasing a 3-year Igniter Premium membership.
        </li>
        <li>
          If you have an active membership, 3 years will be added to your membership end date.
        </li>
        <li>
          Have questions? Give us a call at <a href="tel:1-866-340-1826">1-866-340-1826</a>.
        </li>
      </ul>
    )
  }

  private renderedPaymentTotal() {
    const { paymentDetails, taxInformation } = this.props

    return Number(paymentDetails.total({ taxInformation })).toFixed(2)
  }
}
